import qz from 'qz-tray'

export const connectQZ = async () => {
  if (!qz.websocket.isActive()) {
    try {
      await qz.websocket.connect({ retries: 2, delay: 1 })
      return true
    } catch (e) {
      console.error("QZ Tray connection error:", e)
      return false
    }
  }
  return true
}

export const printWithQZ = async (printerName, pdfUrl) => {
  try {
    const isConnected = await connectQZ()
    if (!isConnected) return false

    const printers = await qz.printers.find(printerName)
    if (!printers) {
      console.warn(`Impresora "${printerName}" no encontrada por QZ Tray`)
      return false
    }

    const config = qz.configs.create(printerName, {
      colorType: 'blackwhite',
      copies: 1,
    })

    const data = [{
      type: 'pixel',
      format: 'pdf',
      flavor: 'file',
      data: pdfUrl
    }]

    await qz.print(config, data)
    return true
  } catch (error) {
    console.error("No se pudo imprimir con QZ:", error)
    return false
  }
}
